/**
 * GpuHeroIllustration.tsx — hero-illustrasjon for /gpu
 *
 * Tre isometriske plattformer koblet med prikkede linjer: container (kuber), GPU-kort og
 * server-rack. Samme stil og temafarger som de andre produktsidene; kun blå og grå.
 */

import { Rack, Cube } from '@/components/invps/parts';
import { Box, iso } from '@/components/product/iso';
import styles from '@/components/product/illustrations.module.css';
import { GpuCard } from './parts';

export default function GpuHeroIllustration({ label }: { label: string }) {
  const A = { x: -2.5, y: 0.5 }; // GPU-kort (foran)
  const B = { x: -2.5, y: -5.5 }; // container (bak)
  const C = { x: 3.5, y: -3.5 }; // rack (høyre)
  const size = 5;

  return (
    <svg className={styles.scene} viewBox="110 40 660 420" role="img" aria-label={label}>
      <polyline className={styles.link} points={`${iso(A.x + 2, A.y, 0)} ${iso(B.x + 2.5, B.y + size, 0)}`} />
      <polyline className={styles.link} points={`${iso(B.x + size, B.y + 3, 0)} ${iso(C.x + 0.5, C.y, 0)}`} />
      <polyline className={styles.link} points={`${iso(A.x + size, A.y + 2, 0)} ${iso(C.x, C.y + 4.5, 0)}`} />

      <Box x={B.x} y={B.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <Cube x={B.x + 0.7} y={B.y + 1.8} z={0.3} size={1.5} tone="light" />
      <Cube x={B.x + 2.6} y={B.y + 1.2} z={0.3} size={1.5} tone="blue" />
      <Cube x={B.x + 1.6} y={B.y + 2.9} z={0.3} size={1.1} tone="deep" />

      <Box x={C.x} y={C.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <Rack x={C.x + 1.2} y={C.y + 1.3} z={0.3} units={4} />

      <Box x={A.x} y={A.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <GpuCard x={A.x + 0.4} y={A.y + 1.4} z={0.3} />
    </svg>
  );
}
